import "./MediaCard.css";
import React from "react";
import PropTypes from "prop-types";
import Card, { CardContent, CardMedia } from "material-ui/Card";
import Typography from "material-ui/Typography";

function MediaCard(props) {
  const {
    title,
    imageUrl,
    imageTitle,
    value,
    subValue,
    units,
    backgroundColor,
    className
  } = props;

  const styles = {
    backgroundColor: {}
  };

  if (backgroundColor) {
    styles.backgroundColor = {
      backgroundColor: backgroundColor
    };
  }
  return (
    <Card className={`media-card card  rounded`}>
      <CardMedia
        className={`media  ${className} rounded-content`}
        style={styles.backgroundColor}
        image={imageUrl}
        title={imageTitle}
        component="img"
      />
      <CardContent>
        <Typography
          variant="headline"
          component="h1"
          align="center"
          className="value"
        >
          {value}
          <span className="units">{units}</span>
        </Typography>
        {subValue && (
          <Typography variant="title" align="center" color="primary">
            {subValue}
          </Typography>
        )}
        <Typography component="p" align="center" className="title">
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
}

MediaCard.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageTitle: PropTypes.string,
  text: PropTypes.string
};

export default MediaCard;



// WEBPACK FOOTER //
// ./src/components/MediaCard/MediaCard.js